module.exports = __webpack_public_path__ + "7c7ab6ceed55cc65abcb45acdbbaded8.svg";